import { getAPI } from '../../api/agent';

const InitAPI = {
  getUser: () => getAPI().get('/user'),
  getSiteStatus: () => getAPI().get('/siteStatus'),
};

export default InitAPI;
